export default __webpack_public_path__ + "img/favicon-96x96.png";